import axios from 'axios';

/** True when a request was cancelled (navigation, unmount, or explicit abort). */
export const isRequestAbortedError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const err = error as { message?: string; code?: string };

  return (
    axios.isCancel(error) ||
    err.code === 'ERR_CANCELED' ||
    err.message === 'Request aborted' ||
    err.message === 'canceled'
  );
};
